__webpack_require__.p = "/IPL-Dashboard/";